<template>
  <div>
    <div class="panel">
      <div class="button left" @click="offset(-10)">-10</div>
      <div class="button left" @click="offset(-1)">-1</div>
      <input v-model="timestamp" />
      <div class="button right" @click="offset(1)">+1</div>
      <div class="button right" @click="offset(10)">+10</div>
    </div>
    <div class="bpanel">
      <div class="button l" @click="play">ここから再生</div>
      <div class="button" @click="timeFromPlayer">プレビューから上書き</div>
    </div>
  </div>
  <!--
  <div class="p-gird">
    
    <div class="p-col-12 bottom">
      <Button class="button" icon="pi pi-play" label="2sec" @click="play" />
      <Button
        class="button"
        icon="pi pi-chevron-down"
        label="プレビューから"
        @click="timeFromPlayer"
      />
    </div>
  </div>
  !-->
</template>

<script>
import { defineComponent } from "vue";
import Button from "primevue/button";
import { useStore } from "vuex";

export default defineComponent({
  name: "TimeSelector",
  components: {},
  props: {
    type: {
      type: String,
      default: "start",
    },
    currentTime: {
      type: Number,
      default: 0,
    },
  },
  data() {
    const timestamp = "00:00:00";
    return {
      timestamp: timestamp,
    };
  },
  setup() {
    const store = useStore();
    return {
      store,
    };
  },
  computed: {
    time() {
      let sum = 0;
      this.timestamp.split(":").forEach((element) => {
        sum *= 60;
        sum += Number(element);
      });
      return sum;
    },
    label2sec() {
      if (this.type === "end") {
        return "2秒前から再生";
      } else {
        return "2秒後まで再生";
      }
    },
  },
  methods: {
    offset(d) {
      let after = this.time + d;
      if (after < 0) after = 0;
      this.timestamp = this.num2stamp(after);
      console.log("this.timestamp", this.timestamp);
    },
    num2stamp(time) {
      const h = Math.floor(time / 3600);
      const m = Math.floor((time % 3600) / 60);
      const s = Math.floor(time % 60);
      const hs = ("00" + h).slice(-2);
      const ms = ("00" + m).slice(-2);
      const ss = ("00" + s).slice(-2);
      return hs + ":" + ms + ":" + ss;
    },
    play() {
      console.log("timeselector", "play");
      // if (this.type === "end") this.$emit("play", this.time - 2);
      // else this.$emit("play", this.time);
      this.$emit("play", this.time);
    },
    timeFromPlayer() {
      console.log(this.store.state.preview.currentTime);
      this.timestamp = this.num2stamp(this.store.state.preview.currentTime);
    },
  },
});
</script>

<style scoped>
.container {
  width: 100%;
  margin: auto;
}
.text {
  width: 30px;
}
input {
  padding: 10px;
  width: 80px;
  margin-left: 10px;
  margin-right: 10px;
  text-align: center;
}
.panel {
  display: flex;
  width: 240px;
  height: 40px;
  outline: 2px solid gray;
  color: rgb(122, 122, 122);
  text-align: center;
  line-height: 40px;
  font-weight: bold;
  user-select: none;
}
.button {
  height: 40px;
  width: 40px;
  background-color: white;
  cursor: pointer;
}
.button:hover {
  background-color: whitesmoke;
}
button:active {
  background-color: rgb(219, 219, 219);
}
.panel > input {
  width: 80px;
  margin: 0px;
  outline: none;
  border: none;
  color: #666;
  font-weight: bold;
}
.panel > .left {
  border-right: 2px solid lightgray;
}
.panel > .right {
  border-left: 2px solid lightgray;
}
.bpanel {
  display: flex;
  width: 244px;
  height: 42px;
  margin-left: -2px;
  color: rgb(122, 122, 122);
  text-align: center;
  line-height: 45px;
  font-weight: bold;
  border-left: 2px solid gray;
  border-right: 2px solid gray;
  border-bottom: 2px solid gray;
}
.bpanel > .button {
  width: 120px;
  font-size: 10pt;
}
.bpanel > .l {
  border-right: 2px solid lightgray;
}
</style>
